
import Vue from 'vue';

Vue.component('rename-folder-vue', {

  mounted() {
    const createFolderBtn = document.getElementById("renameFolderBtn");
    const folderNameInput = document.getElementById("myFolderName");
    const errorText = document.getElementById("errorTextMsg");

    createFolderBtn.addEventListener("click", createFolder);

    function showSuccessMessage() {
      const messageBox = document.createElement("div");
      messageBox.classList.add("message-box");
      messageBox.textContent = "Folder Created Successfully";
      document.body.appendChild(messageBox);
      setTimeout(function() {
        document.body.removeChild(messageBox);
      }, 1000);
    }

    function isValidFolderName(name) {
      const folderNamePattern = /^[a-zA-Z0-9\s]{1,14}$/;
      return folderNamePattern.test(name);
    }

    function createFolder() {
      const folderName = folderNameInput.value.trim();
      const errorMessage = "Invalid folder name!!";

      if (folderName.trim() === "") {
        displayError("Enter folder name");
      } else if (isValidFolderName(folderName)) {

        showSuccessMessage();
        setTimeout(function() {
          folderNameInput.value = ""; // Clear the input after successful creation
          errorText.textContent = "";
          folderNameInput.style.border = "";
        }, 1000);
      } else {
        displayError(errorMessage);
      }
    }

    function displayError(message) {
      errorText.textContent = message;
      folderNameInput.style.border = "1px solid red";
    }
    //input focus logic
    folderNameInput.addEventListener('input', function() {
      this.classList.add('typing');
    });

    folderNameInput.addEventListener('blur', function() {
      if (this.value.trim() === '') {
        this.classList.remove('typing');
      }
    });
  }
});
